import { createColumnHelper, rowSelectionFeature, tableFeatures } from '@tanstack/react-table';
import type { ColumnDef, RowData } from '@tanstack/react-table';

/**
 * `DataTable` n'enregistre qu'une seule fonctionnalité TanStack Table :
 * `rowSelectionFeature`, pour la sélection multiple de lignes (`02` §3,
 * Commandes : « Envoyer maintenant », « Régénérer », « Marquer ignorée »).
 * Tri, pagination et filtres restent pilotés par l'API (`paginationQuerySchema`,
 * `sortQuerySchema` de `@flux/shared`) et reflétés dans l'URL — jamais
 * recalculés côté client (`useDataTableUrlState`, `README-shell.md`).
 * `useTable` ne sert donc qu'au rendu sans état propre (groupes d'en-têtes,
 * lignes, `FlexRender`) plus l'état de sélection ; voir
 * `node_modules/@tanstack/react-table/skills/getting-started` et
 * `.../skills/table-state`.
 *
 * `rowSelectionFeature` est **opt-in au niveau de chaque écran** : elle
 * n'ajoute qu'un état (`rowSelection`) et des méthodes sur `table`/`row`,
 * jamais de colonne ni de comportement visible tant qu'un écran ne fournit
 * pas `rowSelection`/`onRowSelectionChange` à `<DataTable>` (voir
 * `data-table.tsx`). Un écran qui ne les fournit pas n'est donc pas affecté.
 */
export const dataTableFeatures = tableFeatures({ rowSelectionFeature });

export type DataTableFeatures = typeof dataTableFeatures;

export function createDataTableColumnHelper<TData extends RowData>() {
  return createColumnHelper<DataTableFeatures, TData>();
}

export type DataTableColumnDef<TData extends RowData, TValue = unknown> = ColumnDef<
  DataTableFeatures,
  TData,
  TValue
>;
